type MessageType = {
    message: string;
    messageType: 'error' | 'warning' | 'info';
};

type Permissions = {
    isCanChange: '1' | '0';
};

export type GWTMetaData = {
    permissions?: Permissions;
    Message?: MessageType[];
    fatalerror?: '1';
    ipwarning?: string;
};

export type AlertGWTType = {
    Conditions: {
        curvalue: string;
        op: string;
        field: string;
    }[];
    active?: '1' | '0';
    alert: string;
    conditionsOperator: '1' | '0';
    description: string;
    docformat: string;
    document: string;
    engmessage: string;
    engsubject: string;
    extfiles: string;
    mailtype: string;
    message: string;
    messagetype: string;
    multicomp: '1' | '0';
    pdf: '1' | '0';
    recipfield: string;
    recipgroup: string;
    recipuser: string;
    subject: string;
    time: string;
    timefield: string;
    timeunit: string;
    tostatus: string;
    updfield: string;
    validallusers: string;
    validgroup: string;
    validmyself: string;
    validuser: string;
    validusersingroup: string;
    webhook: string;
};

export type AlertOverviewType = {
    action: string;
    alert: string;
    condition?: string;
    details: string;
    description?: string;
    isActive?: 'Y' | 'N';
    title?: string;
    user: string;
    Conditions?: [
        {
            curvalue?: string;
            field: string;
            op?: string;
            secvalue?: string;
            value?: string;
        }
    ];
    conditionsOperator?: '1' | '0';
};

export type BpmAlertResponse = {
    BPM: Array<
        {
            Rules?: Array<{
                Rule: Array<AlertOverviewType>;
                dialogtitle: string;
                listdialogtitle: string;
            }>;
            session?: string;
            alert?: string;
        } & GWTMetaData
    >;
};

export enum GWTRulesType {
    None0 = 0,
    FormRules = 1,
    BPMStatusRules = 2,
    BPMLinkRules = 3,
    Data = 4
}
